import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "input"]

  toggle() {
    const isChecked = this.triggerTarget.checked
    this.inputTargets.forEach(input => {
      input.disabled = !isChecked
    })
  }
}
